import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { ApiErrors, GqlRequestOptions } from '@common/api-request';

import { getUserAccountKakaoConnected as _getUserAccountKakaoConnected, getUserName } from '../graphql/user-account.2';

/**
 * @public
 */
export type AuthState = 'authenticated' | 'pending' | 'failed';

export const useGetUserNameQuery = () => {
  return useQuery(
    ['getUserName'],
    async () => {
      const { data } = await getUserName(null, { show_alert: false, ignore_error: ApiErrors.NOT_LOGGED_IN });
      return data;
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};

export const requestUserName = async (options: GqlRequestOptions) => {
  try {
    const { data } = await getUserName(null, { ...options, show_alert: false, ignore_error: ApiErrors.NOT_LOGGED_IN });
    return data;
  } catch (e) {
    console.error(e);
  }
};

/**
 * @public
 */
export const useIsAuthenticated = () => {
  const [authState, setAuthState] = useState<AuthState>('pending');
  const { data, error } = useGetUserNameQuery();

  useEffect(() => {
    if (error) {
      console.error('failed to get user name');
      setAuthState('failed');
      return;
    }
    if (!data) {
      return;
    }

    setAuthState(data.user_account !== null ? 'authenticated' : 'failed');
  }, [data, error]);

  return {
    isLoggedIn: authState === 'authenticated',
    isLoading: authState === 'pending',
  };
};

/**
 * @public
 */
export const getUserAccountKakaoConnected = _getUserAccountKakaoConnected;
